// Marks the row matching the photo an <s-hero-rotator> is showing.
// data-rotator names the rotator's id; rows carry data-slide-key, and the matching row gets data-active.
class RotatorHighlight extends HTMLElement {
  #abort = null;

  connectedCallback() {
    const rotator = this.dataset.rotator ? document.getElementById(this.dataset.rotator) : null;
    if (!rotator) return;
    this.#abort = new AbortController();
    rotator.addEventListener('rotator:change', (event) => this.#mark(event.detail?.key), { signal: this.#abort.signal });
    // The rotator may have announced before this element upgraded.
    if (rotator.dataset.currentKey !== undefined) this.#mark(rotator.dataset.currentKey);
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #mark(key) {
    for (const row of this.querySelectorAll('[data-slide-key]')) {
      row.toggleAttribute('data-active', row.dataset.slideKey === String(key));
    }
  }
}

if (!customElements.get('s-rotator-highlight')) customElements.define('s-rotator-highlight', RotatorHighlight);
